/**
 * Swiper dependencies
 *
 * @see https://swiperjs.com/get-started
 */
import { Swiper } from 'swiper';
import { Autoplay, Keyboard, Navigation, Pagination } from 'swiper/modules';

/**
 * Initialize the slider.
 *
 * @param {Element} container HTMLElement.
 * @param {Object}  options   Slider parameters.
 *
 * @return {Object} Returns initialized slider instance.
 *
 * @see https://swiperjs.com/swiper-api#parameters
 */
export function SwiperInit(container, options = {}) {
  const parameters = {
    autoplay: {
      delay: 6000,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 1500,
    centeredSlides: options?.centerSlides ?? false,
    createElements: true,
    grabCursor: options?.grabCursor ?? true,
    initialSlide: 0,
    keyboard: true,
    modules: [Autoplay, Keyboard, Navigation, Pagination],
    navigation: {
      nextEl: '.swiper-button-next1',
      prevEl: '.swiper-button-prev1',
    },
    pagination: { enabled: options?.pagination ?? true, clickable: true },
    simulateTouch: options?.simulateTouch ?? true,
  };

  return new Swiper(container, parameters);
}
